import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useTelegram } from '../../../hooks/useTelegram';
import { useUser } from '../../../contexts/UserContext';
import Loader from '../Loader/Loader';

const ProtectedRoute = () => {
  const { isReady } = useTelegram();
  const { loading, isAuthenticated, error, initialized } = useUser();
  console.log('isAuthenticated->', isAuthenticated, 'loading->', loading, 'isReady->', isReady, 'initialized->', initialized)
  // Если данные еще загружаются, показываем загрузчик
  if (loading || !isReady || !initialized) {
    return <Loader splash={true} />;
  }
  
  // Если аутентификация успешна или режим разработки, показываем запрашиваемую страницу
  if (isAuthenticated || process.env.NODE_ENV === 'development') {
    return <Outlet />;
  }

  // Если ошибка аутентификации, перенаправляем на страницу "Не авторизован"
  return <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute; 